<template>
	<div class="container">
		<ul>
			<li class="row"><span
				class="width">hostname: </span> {{ streamer.hostname }}</li>
			<li class="row"><span
				class="width">address: </span> {{ streamer.address }}</li>
			<li class="row"><span
				class="width">multiplier: </span> {{ streamer.multiplier }}</li>
			<li class="row"><span
				class="width">maxlimit: </span> {{ streamer.maxlimit }}</li>
			<li class="row"><span
				class="width">live: </span> {{ streamer.live }}</li>
			<li class="row"><span
				class="width">mysql_port: </span> {{ streamer.mysql_port }}</li>
			<li class="row"><span
				class="width">login: </span> {{ streamer.login }}</li>
			<li class="row"><span
				class="width">password: </span> {{ streamer.password }}</li>
			<!--<li class="row"><span-->
				<!--class="width">operator: </span> {{ streamer.operator }}</li>-->
		</ul>
	</div>
</template>
<script>
	export default {
		name: "StreamersItem",
		props: {
			streamer: Object,
		},
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	.container {
		max-width: 60rem;
		min-width: 30rem;
		height: 15rem;
		background-color: #fff;
		border-radius: 5px 5px 14px 5px;
		padding: 0.5rem;
	}
	.width {
		min-width: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/components/StreamersItem.vue